import { configs } from "configs"
import { getStorageItem, setStorageItem } from "utils/localStorage"

// Get language from local storage
export const getLanguageFromStorage = () => {
  const storedLanguage = getStorageItem("APP_LANGUAGE_STORAGE_KEY")
  if (storedLanguage) {
    const foundLang = configs.languages.find(e => e.key === storedLanguage)
    if (foundLang) {
      return foundLang
    }
  }
  return null
}

// Get default language from config
export const getDefaultLanguage = () => {
  // Find the language marked as default in config
  const defaultLang = configs.languages.find(lang => lang?.default)
  if (defaultLang) {
    return defaultLang
  }

  // Fallback to first language in config
  return configs.languages[0]
}

export const getAppLanguage = () => {
  const storageLang = getLanguageFromStorage()
  if (storageLang) {
    return storageLang
  }

  // 2. Use default language from config
  const defaultLang = getDefaultLanguage()
  setStorageItem("APP_LANGUAGE_STORAGE_KEY", defaultLang.key, true)
  return defaultLang
}

export const checkEnglishLanguage = () => {
  const { key = "en" } = getAppLanguage()
  return key === "en"
}

export const checkArabicLanguage = () => {
  const { key = "en" } = getAppLanguage()
  return key === "ar"
}

export const useLanguage = () => {
  const getCurrentLanguageKey = () => {
    const { key = "en" } = getAppLanguage()
    return key
  }

  const changeAppLanguage = lng => {
    try {
      const currentLang = getAppLanguage()

      // Determine the target language
      let targetLang = lng
      if (!targetLang || typeof targetLang !== "string") {
        if (checkEnglishLanguage()) {
          targetLang = "ar"
        } else if (checkArabicLanguage()) {
          targetLang = "en"
        } else {
          targetLang = "en"
        }
      }

      // Only change if the language is different
      if (targetLang !== currentLang.key) {
        // Store the new language in local storage
        setStorageItem("APP_LANGUAGE_STORAGE_KEY", targetLang, true)

        window.location.reload()

        // Change the i18next language
        //  i18next.changeLanguage(targetLang)
      }
    } catch (error) {
      console.error("Failed to change language:", error)
    }
  }

  return {
    changeAppLanguage,
    isCurrentLanguageEnglish: checkEnglishLanguage(),
    isCurrentLanguageArabic: checkArabicLanguage(),
    getCurrentLanguageKey,
    getAppLanguage,
    getDefaultLanguage,
  }
}
